import { LockClosedIcon, StarIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

/**
 * Displays perk pricing with star or lock icon based on redeemability.
 *
 * @param {Object} props Component props
 * @param {boolean} props.locked Whether perk can be redeemed with points
 * @param {number} props.pointPrice Point price of the perk
 * @returns {JSX.Element} Perk pricing display with icon
 */
function PointsTag({ locked = false, pointPrice, ...restProps }) {
    return (
        <div
            className={clsx(
                'flex items-center gap-5 font-grotesk-bold text-body-mobile-sm md:text-body-mobile-md',
                locked ? 'text-grey' : 'text-kale'
            )}
            data-testid="points-tag"
            {...restProps}
        >
            {locked ? (
                <LockClosedIcon className="size-15" title="Locked icon" />
            ) : (
                <StarIcon className="size-15" title="Star icon" />
            )}
            <span data-testid="points-cost">{pointPrice}</span> PTS
        </div>
    );
}

export default PointsTag;
